module.exports = __webpack_public_path__ + "static/media/hombound1.68dc545d.png";